import { render } from "./History.vue?vue&type=template&id=39d0c9d8"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\survey_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__